import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCar, FaMotorcycle, FaCarSide, FaEllipsisH, FaSearch } from "react-icons/fa";
import './HomeFilter.css';

const HomeFilter = () => {
  const year = Array.from({ length: 2026 - 1990 + 1 }, (_, i) => 2026 - i);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Automobile");
  const [isArchived, setIsArchived] = useState(false);
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [generation, setGeneration] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isCopart, setIsCopart] = useState(true);
  const [isIAAI, setIsIAAI] = useState(true);

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    let filterData = {};
    if (searchQuery.trim() !== "") {
      filterData = {
        "search-type": "vin",
        "lot_id": searchQuery,
      };
    } else {
      filterData = {
        "search-type": "filters",
        "type": activeTab,
        "make": make,
        "model": model,
        "year-from": fromYear,
        "year-to": toYear,
        "auction-type": isCopart && !isIAAI
          ? 1
          : !isCopart && isIAAI
            ? 2
            : undefined,
      };
    }
    navigate("/quicksearch", { state: filterData });
  };

  const isFilterDisabled = searchQuery.trim() !== "";

  const [showMore, setShowMore] = useState(false);

  const moreOptions = [
    "Watercraft",
    "Jet Sky",
    "Boat",
    "Trailers",
    "Mobile Home",
    "Emergency Equipment",
    "Industrial Equipment",
    "Truck",
    "Bus",
    "Other"
  ];

  const makes = [
    "All makes",
    "Acura",
    "Alfa Romeo",
    "American Motors",
    "Aston Martin",
    "Audi",
    "Austin",
    "Bentley",
    "BMW",
    "Bugatti",
    "Buick",
    "Cadillac",
    "Chevrolet",
    "Chrysler",
    "Daewoo",
    "Daihatsu",
    "Datsun",
    "Delorean",
    "Desoto",
    "Dodge",
    "Eagle",
    "Ferrari",
    "Fiat",
    "Fisker",
    "Ford",
    "Genesis",
    "GEO",
    "GMC",
    "Honda",
    "Hummer",
    "Hyundai",
    "Infiniti",
    "Jaguar",
    "Jeep",
    "KIA",
    "Lamborghini",
    "Land Rover",
    "Lexus",
    "Lincoln",
    "Lotus",
    "Maserati",
    "Maybach",
    "Mazda",
    "Mclaren",
    "Mercedes-Benz",
    "Mercury",
    "MG",
    "Mini",
    "Mitsubishi",
    "Nissan",
    "Peugeot",
    "Porsche",
    "RAM",
    "Renault",
    "Rolls-Royce",
    "Subaru",
    "Suzuki",
    "Tesla",
    "Toyota",
    "Volkswagen",
    "Volvo",
    "Other"
  ];

  return (
    <div className="container-fluid px-lg-5">
      <div className="home-filter-card">
        <div className={`filter-tabs-row ${isFilterDisabled ? "opacity-50 pointer-events-none" : ""}`}>
          <div className="filter-tabs">
            {[
              { id: "Automobile", icon: <FaCar /> },
              { id: "Motorcycle", icon: <FaMotorcycle /> },
              { id: "ATV", icon: <FaCarSide /> },
            ].map((tab) => (
              <div
                key={tab.id}
                className={`filter-tab ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => !isFilterDisabled && setActiveTab(tab.id)}
              >
                {tab.icon}
                <span>{tab.id}</span>
              </div>
            ))}

            <div
              className={`filter-tab more-tab-wrapper ${moreOptions.includes(activeTab) || activeTab === "More" ? "active" : ""}`}
              onClick={() => !isFilterDisabled && setShowMore(!showMore)}
              onMouseLeave={() => setShowMore(false)}
            >
              <FaEllipsisH />
              <span>{moreOptions.includes(activeTab) ? activeTab : "More"}</span>

              {showMore && (
                <div className="more-dropdown">
                  {moreOptions.map(option => (
                    <div
                      key={option}
                      className={`more-option ${activeTab === option ? "selected" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveTab(option);
                        setShowMore(false);
                      }}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="archived-toggle-wrapper">
            <label className="switch-box">
              <input
                type="checkbox"
                checked={isArchived}
                onChange={(e) => !isFilterDisabled && setIsArchived(e.target.checked)}
                disabled={isFilterDisabled}
              />
              <span className="switch-slider grey-bg"></span>
            </label>
            <span>Archived</span>
          </div>
        </div>

        <div className="filter-content-grid">

          <div className={`filter-left-col ${isFilterDisabled ? "opacity-50 pointer-events-none" : ""}`}>
            <select
              className="filter-select"
              value={make}
              onChange={(e) => setMake(e.target.value)}
              disabled={isFilterDisabled}
            >
              {makes.map((item, index) => (
                <option key={index} value={item === "All makes" ? "All" : item}>
                  {item}
                </option>
              ))}
            </select>
            <select
              className="filter-select"
              value={generation}
              onChange={(e) => setGeneration(e.target.value)}
              disabled={isFilterDisabled}
            >
              <option value="All">All generations</option>
            </select>
          </div>

          <div className={`filter-left-col ${isFilterDisabled ? "opacity-50 pointer-events-none" : ""}`}>
            <select
              className="filter-select"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              disabled={isFilterDisabled}
            >
              <option value="All">All models</option>
              <option value="3-series">3-series</option>
              <option value="carrera">carrera</option>
              <option value="G-TR">G-TR</option>
              <option value="Mecan">Mecan</option>
              <option value="N-series">N-series</option>
            </select>
            <div className="filter-middle-col">
              <select
                className="filter-select"
                value={fromYear}
                onChange={(e) => setFromYear(e.target.value)}
                disabled={isFilterDisabled}
              >
                <option value="">From</option>
                {year.map(y => <option key={y} value={y}>{y}</option>)}
              </select>
              <select
                className="filter-select"
                value={toYear}
                onChange={(e) => setToYear(e.target.value)}
                disabled={isFilterDisabled}
              >
                <option value="">To</option>
                {year.map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
          </div>

          <div className="or-divider">or</div>

          <div className="filter-left-col">
            <div className="vin-lot-search-container">
              <input
                type="text"
                className="filter-input"
                placeholder="Search by vehicle title"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
              />
              <button className="search-icon-btn mt-0" onClick={handleSubmit}>
                <FaSearch />
              </button>
            </div>

            <div className="filter-footer-row">
              <div className={`auction-source-toggles ${isFilterDisabled ? "opacity-50 pointer-events-none" : ""}`}>
                <div className="source-toggle-item">
                  <label className="switch-box">
                    <input
                      type="checkbox"
                      checked={isCopart}
                      onChange={(e) => !isFilterDisabled && setIsCopart(e.target.checked)}
                      disabled={isFilterDisabled}
                    />
                    <span className="switch-slider blue-bg"></span>
                  </label>
                  <span>Copart</span>
                </div>
                <div className="source-toggle-item">
                  <label className="switch-box">
                    <input
                      type="checkbox"
                      checked={isIAAI}
                      onChange={(e) => !isFilterDisabled && setIsIAAI(e.target.checked)}
                      disabled={isFilterDisabled}
                    />
                    <span className="switch-slider red-bg"></span>
                  </label>
                  <span>IAAI</span>
                </div>
              </div>

              <button className="filter-submit-btn mt-0" onClick={handleSubmit}>
                Show vehicles
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeFilter;